import { Component } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { SistRadnihMesta } from './sist-radnih-mesta';

@Component({
  selector: 'app-sist-radnih-mesta-stavka-inline-update',
  templateUrl: './sist-radnih-mesta-stavka-inline-update.component.html'
})
export class SistRadnihMestaStavkaInlineUpdateComponent
extends BaseInlineUpdateComponent<SistRadnihMesta> {

  constructor(
    protected inlineContainerService: InlineContainerService<SistRadnihMesta>
  )
  {
    super(inlineContainerService);
   }
}
